<template>
  <div :class="$style.ctn">
    <template v-if="ancors">
      <button :class="$style.button">
        {{ name }}
      </button>
      <div :class="$style.dropMenuCtn">
        <ul :class="$style.dropMenu">
          <li v-for="(ancor, i) in ancors" :key="i">
            <a :href="`#${ancor}`">{{ ancor }}</a>
          </li>
        </ul>
      </div>
    </template>
    <template v-else>
      <a :class="$style.button" :href="`#${name}`">{{ name }}</a>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    ancors: { type: Array, default: null },
    name: { type: String, required: true },
  },
});
</script>

<style lang="scss" module>
.ctn {
  position: relative;

  &:hover {
    .button {
      border-color: #00b0e8;
    }
    .dropMenuCtn {
      display: block;
    }
  }
}

.button {
  font-size: 14px;
  color: #3f4757;
  font-weight: 500;
  letter-spacing: 0.02em;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  border-radius: 1px;
  padding-bottom: 10px;
  display: block;
}
.dropMenuCtn {
  display: none;
  position: absolute;
  top: 100%;
  padding-top: 4px;

  @media screen and (max-width: 1040px) {
    position: relative;
    display: block;
    top: 0;
    padding: 0;
  }
}
.dropMenu {
  list-style: none;
  background: #fafbfc;
  border: 1px solid var(--table-border-color);
  border-radius: 2px;
  min-width: 145px;

  @media screen and (max-width: 1040px) {
    background: none;
    border: none;
    padding-bottom: 8px;
  }

  & > li > a {
    padding: 4px 10px 4px 10px;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0.02em;
    color: #3f4757;
    display: block;

    &:not(:hover) {
      opacity: 0.7;
    }

    @media screen and (max-width: 1040px) {
      &:not(:hover) {
        opacity: 1;
      }
    }
  }
}
</style>
